function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "primary-fill",
  fill: "#D6D6D6",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.579 31.865c8.604 0 15.578-7.133 15.578-15.932C31.157 7.133 24.183 0 15.58 0S0 7.133 0 15.933c.01 8.795 6.98 15.921 15.579 15.932zm0-28.352c6.707 0 12.144 5.56 12.144 12.42s-5.437 12.42-12.144 12.42-12.144-5.56-12.144-12.42c.008-6.856 5.44-12.412 12.144-12.42z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  stroke: "#D6D6D6",
  strokeWidth: 0.9,
  d: "M21 11.93l-1.431-1.43-4.07 4.07-4.068-4.07L10 11.93 14.069 16 10 20.07l1.43 1.43 4.07-4.069 4.069 4.069L21 20.07 16.93 16z"
}));

const SvgIcVSelected = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcVSelected, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-v-selected.5545a523.svg";
export { ForwardRef as ReactComponent };